import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

interface Payload {
  documentId: string;
  employeeId?: string;
  objectKey?: string;
  fileName?: string;
  ocrRequired?: boolean;
}

const useCompleteFileUploadQuery = () => {
  const { mutateAsync, isLoading } = useMutation((payload: Payload) =>
    api.post(API_URL.DOCUMENTS_FILES_LINK_COMPLETE_BY_DOCUMENT_ID(payload.documentId), {
      employee_id: payload.employeeId,
      object_key: payload.objectKey,
      file_name: payload.fileName,
      ...payload?.ocrRequired ? { ocr_required: true } : {},
    })
  );

  return {
    completeFileUpload: mutateAsync,
    isLoading,
  };
};

export default useCompleteFileUploadQuery;
